export default __webpack_public_path__ + "static/media/luggageStorage.c1974aff.jpg";